<app-loading *ngIf="contentReady"></app-loading>

<section
  class="bbm-page"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar">
            <i
              class="fa-solid fa-bell"
              aria-hidden="true"
            ></i>
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ 'notificationMobile.title' | transloco }}
            </span>

            <h2>
              {{ 'notificationMobile.title' | transloco }}
            </h2>

            <p>
              {{ 'notificationMobile.subtitle' | transloco }}
            </p>
          </div>

        </div>

      </div>

    </section>

    <!-- NOTIFICATION FORM -->
    <form
      class="bbm-form-ticket"
      [formGroup]="notificationForm"
      (ngSubmit)="addNotification()"
      enctype="multipart/form-data"
    >

      <!-- FORM HEADER -->
      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'notificationMobile.formTitle' | transloco }}
          </span>

          <h3>
            {{ 'notificationMobile.formTitle' | transloco }}
          </h3>

          <p>
            {{ 'notificationMobile.formSubtitle' | transloco }}
          </p>
        </div>
      </div>

      <div class="bbm-form-grid">

        <!-- ARABIC TITLE -->
        <div class="bbm-field">
          <label for="notification_head_ar">
            {{ 'notificationMobile.fields.titleAr' | transloco }}
          </label>

          <input
            id="notification_head_ar"
            class="bbm-control"
            type="text"
            formControlName="notification_head_ar"
            [placeholder]="
              'notificationMobile.placeholders.titleAr'
                | transloco
            "
            [ngClass]="{
              'is-invalid':
                notificationForm.get('notification_head_ar')?.touched &&
                notificationForm.get('notification_head_ar')?.invalid,
              'is-valid':
                notificationForm.get('notification_head_ar')?.touched &&
                notificationForm.get('notification_head_ar')?.valid
            }"
          >
        </div>

        <!-- ENGLISH TITLE -->
        <div class="bbm-field">
          <label for="notification_head_en">
            {{ 'notificationMobile.fields.titleEn' | transloco }}
          </label>

          <input
            id="notification_head_en"
            class="bbm-control"
            type="text"
            formControlName="notification_head_en"
            [placeholder]="
              'notificationMobile.placeholders.titleEn'
                | transloco
            "
            [ngClass]="{
              'is-invalid':
                notificationForm.get('notification_head_en')?.touched &&
                notificationForm.get('notification_head_en')?.invalid,
              'is-valid':
                notificationForm.get('notification_head_en')?.touched &&
                notificationForm.get('notification_head_en')?.valid
            }"
          >
        </div>

        <!-- ARABIC BODY -->
        <div class="bbm-field bbm-field-wide">
          <label for="notification_body_ar">
            {{ 'notificationMobile.fields.bodyAr' | transloco }}
          </label>

          <textarea
            id="notification_body_ar"
            class="bbm-control bbm-textarea"
            rows="4"
            formControlName="notification_body_ar"
            [placeholder]="
              'notificationMobile.placeholders.bodyAr'
                | transloco
            "
          ></textarea>
        </div>

        <!-- ENGLISH BODY -->
        <div class="bbm-field bbm-field-wide">
          <label for="notification_body_en">
            {{ 'notificationMobile.fields.bodyEn' | transloco }}
          </label>

          <textarea
            id="notification_body_en"
            class="bbm-control bbm-textarea"
            rows="4"
            formControlName="notification_body_en"
            [placeholder]="
              'notificationMobile.placeholders.bodyEn'
                | transloco
            "
          ></textarea>
        </div>

        <!-- DESKTOP IMAGE -->
        <div class="bbm-field">
          <label>
            {{ 'notificationMobile.fields.desktopImage' | transloco }}
          </label>

          <div
            class="bbm-upload-zone"
            role="button"
            tabindex="0"
            (click)="desktopFileInput.click()"
            (keydown.enter)="desktopFileInput.click()"
            (keydown.space)="desktopFileInput.click(); $event.preventDefault()"
          >
            <input
              #desktopFileInput
              type="file"
              hidden
              accept="image/*"
              (change)="onFileSelected($event)"
            >

            <!-- DESKTOP EMPTY STATE -->
            <div
              *ngIf="!desktopPreview"
              class="bbm-upload-placeholder"
            >
              <span class="bbm-upload-icon">
                <i
                  class="fa-solid fa-image"
                  aria-hidden="true"
                ></i>
              </span>

              <strong>
                {{ 'notificationMobile.upload.desktop' | transloco }}
              </strong>

              <small>
                {{ 'notificationMobile.upload.format' | transloco }}
              </small>
            </div>

            <!-- DESKTOP PREVIEW -->
            <div
              *ngIf="desktopPreview"
              class="bbm-image-preview"
            >
              <img
                [src]="desktopPreview"
                [alt]="'desktop preview' | transloco"
              >

              <button
                type="button"
                class="
                  bbm-action-btn
                  bbm-action-primary
                  bbm-action-compact
                  bbm-image-change-btn
                "
                (click)="
                  desktopFileInput.click();
                  $event.stopPropagation()
                "
              >
                <i
                  class="fa-regular fa-image"
                  aria-hidden="true"
                ></i>

                <span>
                  {{ 'notificationMobile.buttons.changeImage' | transloco }}
                </span>
              </button>
            </div>

          </div>
        </div>

        <!-- MOBILE IMAGE -->
        <div class="bbm-field">
          <label>
            {{ 'notificationMobile.fields.mobileImage' | transloco }}
          </label>

          <div
            class="bbm-upload-zone"
            role="button"
            tabindex="0"
            (click)="mobileFileInput.click()"
            (keydown.enter)="mobileFileInput.click()"
            (keydown.space)="mobileFileInput.click(); $event.preventDefault()"
          >
            <input
              #mobileFileInput
              type="file"
              hidden
              accept="image/*"
              (change)="onMobileImageSelected($event)"
            >

            <!-- MOBILE EMPTY STATE -->
            <div
              *ngIf="!mobilePreview"
              class="bbm-upload-placeholder"
            >
              <span class="bbm-upload-icon">
                <i
                  class="fa-solid fa-mobile-screen"
                  aria-hidden="true"
                ></i>
              </span>

              <strong>
                {{ 'notificationMobile.upload.mobile' | transloco }}
              </strong>

              <small>
                {{ 'notificationMobile.upload.format' | transloco }}
              </small>
            </div>

            <!-- MOBILE PREVIEW -->
            <div
              *ngIf="mobilePreview"
              class="bbm-image-preview"
            >
              <img
                [src]="mobilePreview"
                [alt]="'mobile preview' | transloco"
              >

              <button
                type="button"
                class="
                  bbm-action-btn
                  bbm-action-primary
                  bbm-action-compact
                  bbm-image-change-btn
                "
                (click)="
                  mobileFileInput.click();
                  $event.stopPropagation()
                "
              >
                <i
                  class="fa-regular fa-image"
                  aria-hidden="true"
                ></i>

                <span>
                  {{ 'notificationMobile.buttons.changeImage' | transloco }}
                </span>
              </button>
            </div>

          </div>
        </div>

        <!-- LINK -->
        <div class="bbm-field bbm-field-wide">
          <label for="link">
            {{ 'notificationMobile.fields.link' | transloco }}
          </label>

          <input
            id="link"
            class="bbm-control"
            type="url"
            formControlName="link"
            placeholder="https://example.com"
            [ngClass]="{
              'is-invalid':
                notificationForm.get('link')?.touched &&
                notificationForm.get('link')?.invalid,
              'is-valid':
                notificationForm.get('link')?.touched &&
                notificationForm.get('link')?.valid
            }"
          >
        </div>

      </div>

      <!-- SUBMIT -->
      <div class="bbm-form-actions">

        <button
          class="
            bbm-action-btn
            bbm-action-success
            bbm-action-wide
          "
          type="submit"
          [disabled]="notificationForm.invalid"
        >
          <i
            class="fa-solid fa-paper-plane"
            aria-hidden="true"
          ></i>

          <span>
            {{ 'notificationMobile.buttons.submit' | transloco }}
          </span>
        </button>

      </div>

    </form>

    <!-- LIST HEADER -->
    <section class="bbm-list-head">
      <div>
        <span>
          {{ 'notificationMobile.itemsCount' | transloco }}
        </span>

        <h3>
          {{ 'notificationMobile.listTitle' | transloco }}
        </h3>
      </div>

      <strong class="bbm-list-counter">
        {{ visibleNotifications.length }}
        /
        {{ allData.length }}
      </strong>
    </section>

    <!-- NO DATA -->
    <div
      *ngIf="noData && !contentReady"
      class="bbm-empty-state"
    >
      <app-nodata></app-nodata>
    </div>

    <!-- NOTIFICATIONS LIST -->
    <section
      class="bbm-ticket-list"
      *ngIf="!noData"
    >
      <article
        class="bbm-ticket"
        *ngFor="let element of visibleNotifications"
      >

        <!-- NOTIFICATION TOP -->
        <div class="bbm-ticket-top">

          <div class="bbm-main-info">

            <div class="bbm-avatar">
              <i
                class="fa-solid fa-bell"
                aria-hidden="true"
              ></i>
            </div>

            <div class="bbm-copy">
              <span>
                {{ 'notificationMobile.title' | transloco }}
              </span>

              <h3>
                {{
                  isAr
                    ? (element.notification_head_ar || '-')
                    : (element.notification_head_en || '-')
                }}
              </h3>
            </div>

          </div>

          <button
            type="button"
            class="
              bbm-action-btn
              bbm-action-danger
              bbm-icon-action
            "
            (click)="deleteItem(element.id)"
          >
            <i
              class="fa-solid fa-trash"
              aria-hidden="true"
            ></i>
          </button>

        </div>

        <!-- LANGUAGE CONTENT -->
        <div class="bbm-details-grid">

          <!-- ARABIC CONTENT -->
          <div
            class="bbm-detail-chip bbm-detail-primary"
            dir="rtl"
          >
            <i
              class="fa-solid fa-language"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'notificationMobile.labels.ar' | transloco }}
            </span>

            <div class="bbm-detail-value">
              <strong>
                {{ element.notification_head_ar || '-' }}
              </strong>

              <p>
                {{
                  element.notification_body_ar ||
                  ('notificationMobile.noContent' | transloco)
                }}
              </p>
            </div>
          </div>

          <!-- ENGLISH CONTENT -->
          <div
            class="bbm-detail-chip"
            dir="ltr"
          >
            <i
              class="fa-solid fa-language"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'notificationMobile.labels.en' | transloco }}
            </span>

            <div class="bbm-detail-value">
              <strong>
                {{ element.notification_head_en || '-' }}
              </strong>

              <p>
                {{
                  element.notification_body_en ||
                  ('notificationMobile.noContent' | transloco)
                }}
              </p>
            </div>
          </div>

        </div>

        <!-- NOTIFICATION LINK -->
        <div class="bbm-ticket-section">

          <a
            *ngIf="element.link"
            class="
              bbm-action-btn
              bbm-action-primary
              bbm-action-wide
            "
            [href]="element.link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i
              class="fa-solid fa-link"
              aria-hidden="true"
            ></i>

            <span>
              {{ element.link }}
            </span>
          </a>

          <div
            *ngIf="!element.link"
            class="bbm-alert bbm-alert-warning"
          >
            <i
              class="fa-solid fa-link-slash"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'notificationMobile.noLink' | transloco }}
            </span>
          </div>

        </div>

      </article>
    </section>

    <!-- LOAD MORE -->
    <div
      class="bbm-actions-grid"
      *ngIf="
        !noData &&
        !contentReady &&
        hasMoreNotifications
      "
    >
      <button
        class="
          bbm-action-btn
          bbm-action-primary
          bbm-action-wide
        "
        type="button"
        (click)="loadMore()"
      >
        <i
          class="fa-solid fa-chevron-down"
          aria-hidden="true"
        ></i>

        <span>
          {{ 'notificationMobile.buttons.loadMore' | transloco }}
        </span>
      </button>
    </div>

    <!-- END OF LIST -->
    <div
      class="bbm-end-state"
      *ngIf="
        !noData &&
        !contentReady &&
        !hasMoreNotifications &&
        allData.length
      "
    >
      {{ 'notificationMobile.endOfList' | transloco }}
    </div>

  </div>
</section>